import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';

import { list } from '~/actions/actions';

const defaults = {};

class BoxStatusListSettings extends Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
    list(this.props.dispatch, this.context.apiClient);
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setOutdataValues(obj) {
    this.setState(
      { outdata: { ...this.state.outdata, ...obj } },
      this.onChange
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Dropdown
          onChange={val => this.setOutdataValue('actionId', val)}
          source={this.props.actions}
          value={this.state.outdata.actionId}
          label="Action"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actions: state
    .getIn(['actions', 'items'])
    .map(action => ({
      value: action.get('id'),
      label: action.get('name')
    }))
    .valueSeq()
    .toArray()
});

export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(BoxStatusListSettings);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxStatusList/settings.js